<div class='relative'>
    <div class='max-w-xl pt-2' [class]='product ? "transition-opacity opacity-100 duration-500" : "opacity-0"'>
        <ng-container *ngFor='let optionGroup of product?.optionGroups; trackBy: trackById'>
            <div class='mb-4 rounded-sm' [class.warn-pulse]='displayOptionsWarning && missingOptionGroupIds.includes(optionGroup.id)'>
                <div class='flex items-center justify-between'>
                    <div class='text-sm font-medium text-gray-900'>{{ optionGroup.name | uppercaseFirst }}</div>
                </div>

                <fieldset class='mt-2'>
                    <legend class='sr-only'>Select {{ optionGroup.name }}</legend>
                    <div class='grid gap-3' [ngClass]='optionColGridClass(optionGroup.id)'>
                        <ng-container
                            *ngFor='
                            let option of sortedOptions(optionGroup.options);
                            trackBy: trackById;
                            index as i
                        '
                        >
                            <label
                                [ngClass]="{
                                'bg-primary-100 border-primary-300 text-primary-800 hover:bg-primary-200':
                                    selectedOptions[optionGroup.id] === option.id,
                                'bg-white border-gray-200 text-gray-900 hover:bg-gray-50':
                                    selectedOptions[optionGroup.id] !== option.id,
                                'bg-gray-200 opacity-60':
                                    variantIsOutOfStock(optionGroup.id, option.id) &&
                                    selectedOptions[optionGroup.id] !== option.id,
                                'ring-2 ring-offset-2 ring-primary-500':
                                    activeOptionGroupId === optionGroup.id &&
                                    selectedOptions[optionGroup.id] === option.id
                            }"
                                *ngIf='optionsAvailable[option.id] === true'
                                class='border-2 cursor-pointer rounded-sm py-1 px-1 flex items-center justify-center text-sm font-medium uppercase sm:flex-1 focus:ring-2 focus:ring-offset-2 focus:ring-primary-500'
                            >
                                <input
                                    type='radio'
                                    [disabled]='optionsAvailable[option.id] !== true'
                                    [name]='optionGroup.code'
                                    [value]='option.id'
                                    class='sr-only'
                                    (focus)='focusOptionGroup(optionGroup.id)'
                                    (blur)='blurOptionGroup()'
                                    [(ngModel)]='selectedOptions[optionGroup.id]'
                                    (ngModelChange)='updateSelectedVariant()'
                                    [attr.aria-labelledby]="optionGroup.code + '-' + i + '-label'"
                                />
                                <p [id]="optionGroup.code + '-' + i + '-label'">
                                    {{ option.name }}
                                </p>
                            </label>
                        </ng-container>
                    </div>
                </fieldset>
            </div>
        </ng-container>

        <kb-shipping-info-label [shippingInfo]='shippingInfo$ | async'></kb-shipping-info-label>

        <kb-selected-variant-controls
            [adjustedQty]='adjustedQty'
            [selectedVariant]='selectedVariant'
            [inCartQty]='inCartQty[selectedVariant?.id]'
            [selectOptionLabel]='selectOptionLabel'
            [qualifiesForLetterboxService]="qualifiesForLetterboxService"
            (addToCartClick)='addToCartClick.emit($event)'
            (setQuantity)='manuallySetQuantity(selectedVariant?.id, $event)'
            (addToCartHover)='checkAllOptionsSelected()'
            [inWishlists]='variantAppearsInWishlists(selectedVariant?.id)'
            (addToWishlistClick)='addToWishlistClick.emit($event)'
        ></kb-selected-variant-controls>
    </div>
    <div *ngIf='!product' class='p-12 mx-auto rounded absolute w-full top-12'>
        <p class='text-2xl text-gray-500 animate-pulse text-center'>Loading...</p>
    </div>
</div>
